<mat-dialog-title>
</mat-dialog-title>

<mat-dialog-content>
    <p>{{ customerQuestion }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end" style="margin: 0px 20px 20px 20px;">
    <button mat-button class="btn-cancel" (click)="notProceed()">{{ 'COMMON_BTN_NO' | translate }}</button>
    <button mat-button class="btn-save" (click)="proceed()">{{ 'COMMON_BTN_YES' | translate }}</button>
</mat-dialog-actions>